export default __webpack_public_path__ + "static/media/goshen67.997950b0.jpg";